<div class="avatar" [style]="avatarStyle | async"></div>
